import { nextTick, ref, defineComponent, toRefs, PropType, computed } from '@vue/composition-api';
import { AdgroupFormData, CampaignFormData, FullNormalFormData, AcoFormData } from '@tt4b/ttam-enums';
import { useCreativeDefferedDeepLinkValidate } from '@tt4b/ttam-hooks';
import formItemRejectReason from '@/components/common/form-item-reject-reason/index.vue';

import CreativeDeepLink from '../index';

const name = 'ttam-creative-deffered-deeplink-compose';
export default defineComponent({
  name,
  components: {
    formItemRejectReason,
    TtamCreativeDefferedDeeplinkInput: CreativeDeepLink.TtamCreativeDefferedDeepLinkInput,
    TtamCreativeDefferedDeeplinkSwitch: CreativeDeepLink.TtamCreativeDefferedDeepLinkSwitch,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData & AcoFormData>,
      default: () => ({}),
    },
    rejectReason: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    isDisabledCreative: {
      type: Boolean,
      default: () => false,
    },
  },
  setup(props, { emit }) {
    const { adgroupData, campaignData, creativeData, isDisabledCreative } = toRefs(props);
    const viDefferedDeeplinkUrlRef = ref();

    const _isOpenUrl = computed({
      get: () => creativeData.value.isOpenUrl,
      set: v => {
        emit('is-open-url-change', v ? 1 : 0);

        // 不使用deffered-deeplink后，清除表单校验状态
        nextTick(() => {
          viDefferedDeeplinkUrlRef.value?.clearValidate?.();
        });
      },
    });

    const _openUrl = computed({
      get: () => creativeData.value.openUrl,
      set: val => {
        emit('open-url-change', val);
      },
    });

    const { defferedDeepLinkUrlValidator } = useCreativeDefferedDeepLinkValidate();

    const commonProps = {
      adgroupData,
      campaignData,
    };

    const { disabled } = CreativeDeepLink.usePropsDisabled({
      ...commonProps,
      isDisabledCreative,
    });

    const { hint } = CreativeDeepLink.useSwitchPropsHint(commonProps);

    return {
      name,

      _isOpenUrl,
      _openUrl,

      viDefferedDeeplinkUrlRef,

      defferedDeepLinkUrlValidator,
      disabled,
      hint,
    };
  },
});
